import React from 'react';
import { User } from '../../types';
import { ProfileAvatar } from './ProfileAvatar';
import { getDisplayName } from '../../utils/helpers';

interface ProfileHeaderProps {
  user: User;
  avatarPreview?: string | null;
  loading: boolean;
  hasChanges: boolean;
  onEditClick: () => void;
  onCancelClick: () => void;
  onSaveClick: () => void;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  user,
  avatarPreview,
  loading,
  hasChanges,
  onEditClick,
  onCancelClick,
  onSaveClick
}) => {
  return (
    <>
      <div className="fixed top-6 right-6 z-10 flex space-x-2">
        <button
          onClick={onCancelClick}
          className="px-4 py-2 rounded-full shadow-lg backdrop-blur-sm bg-white/90 text-gray-700 hover:shadow-xl hover:bg-white text-sm font-medium border border-gray-200 transition-all duration-200"
        >
          Cancel
        </button>
        <button
          onClick={onSaveClick}
          disabled={loading || !hasChanges}
          className="px-4 py-2 rounded-full shadow-lg backdrop-blur-sm bg-green-600/95 text-white hover:shadow-xl hover:bg-green-700 text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-lg"
        >
          {loading ? (
            <span className="flex items-center">
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Saving...
            </span>
          ) : (
            'Save'
          )}
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-green-600 h-16"></div>
        <div className="px-6 pb-6">
          <div className="flex items-end -mt-4">
            <div className="flex items-end space-x-4">
              <ProfileAvatar user={user} previewUrl={avatarPreview} />
              <div className="pb-1 min-w-0">
                <h1 className="text-2xl font-bold text-gray-900 truncate">{user.username}</h1>
                <p className="text-gray-600 truncate">{user.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    
  );
};
